!function() {
    var StackCards = function(element) {
        if (!element) return;
        this.element = element;
        this.cards = this.element.getElementsByClassName("js-stacking-cards__item");
        if (this.cards.length === 0) return;

        this.scrollingHandler = false;
        this.isScrolling = false;

        var self = this;

        // Wait for styles and images to fully load before initializing
        window.addEventListener("load", function() {
            initializeStack(self);
            updateStackPosition.call(self);
        });

        new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                if (self.scrollingHandler) return;
                self.scrollingHandler = function() {
                    if (!self.isScrolling) {
                        self.isScrolling = true;
                        window.requestAnimationFrame(updateStackPosition.bind(self));
                    }
                };
                window.addEventListener("scroll", self.scrollingHandler);
            } else {
                if (!self.scrollingHandler) return;
                window.removeEventListener("scroll", self.scrollingHandler);
                self.scrollingHandler = false;
            }
        }, {
            threshold: [0, 1]
        }).observe(this.element);

        this.element.addEventListener("resize-stacking-cards", function() {
            initializeStack(self);
            updateStackPosition.call(self);
        });
    };

    function initializeStack(instance) {
        instance.stackGap = getComputedStyle(instance.element).getPropertyValue("--stacking-cards-gap");

        var tempElement = document.createElement("div");
        tempElement.setAttribute("style", "opacity:0; visibility: hidden; position: absolute; height:" + instance.stackGap);
        instance.element.appendChild(tempElement);
        instance.stackGap = parseInt(getComputedStyle(tempElement).getPropertyValue("height"));
        instance.element.removeChild(tempElement);

        instance.elementHeight = instance.element.offsetHeight;
        if (!instance.cards.length) return;

        var firstCardStyle = getComputedStyle(instance.cards[0]);
        instance.cardTop = Math.floor(parseFloat(firstCardStyle.getPropertyValue("top")));
        instance.cardHeight = Math.floor(parseFloat(firstCardStyle.getPropertyValue("height")));
        instance.windowHeight = window.innerHeight;

        instance.element.style.paddingBottom = isNaN(instance.stackGap) ? "0px" : (instance.stackGap * (instance.cards.length - 1)) + "px";

        for (var i = 0; i < instance.cards.length; i++) {
            instance.cards[i].style.transform = isNaN(instance.stackGap) ? "none" : "translateY(" + instance.stackGap * i + "px)";
        }
    }

    function updateStackPosition() {
        if (isNaN(this.stackGap)) {
            this.isScrolling = false;
            return;
        }
    
        var stackTopOffset = this.element.getBoundingClientRect().top;
        if (!this.cards.length || 
            (this.cardTop - stackTopOffset + this.windowHeight - this.elementHeight - this.cardHeight + this.stackGap + this.stackGap * this.cards.length > 0)) {
            this.isScrolling = false;
            return;
        }
    
        for (var i = 0; i < this.cards.length; i++) {
            var offset = this.cardTop - stackTopOffset - i * (this.cardHeight + this.stackGap);
    
            if (offset > 0) {
                // Unique scaling factor for each card
                let scaleFactor = 1 - Math.min(0.3, Math.max(0, offset / this.cardHeight * 0.3)) * (1 - i * 0.25);
                this.cards[i].offsetHeight; // Force layout reflow
                this.cards[i].style.transform = `translateY(${this.stackGap * i}px) scale(${scaleFactor})`;
            } else {
                this.cards[i].style.transform = `translateY(${this.stackGap * i}px)`;
            }
        }
        this.isScrolling = false;
    }
    
    document.addEventListener("DOMContentLoaded", function () {
        var stackCardElements = document.getElementsByClassName("js-stacking-cards");
        if (stackCardElements.length === 0) return;

        var stackInstances = [];
        for (var j = 0; j < stackCardElements.length; j++) {
            let instance = new StackCards(stackCardElements[j]);
            stackInstances.push(instance);
        }

        var resizeTimer = false;
        var resizeEvent = new CustomEvent("resize-stacking-cards");

        function triggerResizeEvent() {
            for (var k = 0; k < stackInstances.length; k++) {
                stackInstances[k].element.dispatchEvent(resizeEvent);
            }
        }

        window.addEventListener("resize", function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(triggerResizeEvent, 500);
        });
    });
}();
